import React from "react";
import { Calendar } from "react-multi-date-picker";
const DATE_FORMAT = "YYYY-MM-DD";
const MONTHS = [
    "januari",
    "februari",
    "mars",
    "april",
    "maj",
    "juni",
    "juli",
    "augusti",
    "september",
    "oktober",
    "november",
    "december"
];
const WEEK_DAYS = ["sö", "må", "ti", "on", "to", "fr", "lö"];
const MenigoCalendar = (props) => {
    return (React.createElement(Calendar, { value: props.value, months: MONTHS, weekStartDayIndex: 1, weekDays: WEEK_DAYS, multiple: false, monthYearSeparator: " ", format: DATE_FORMAT, disableYearPicker: true, disableMonthPicker: true, onFocusedDateChange: props.onFocusedDateChange, className: "menigo-calendar", mapDays: props.mapDays }));
};
export default MenigoCalendar;
